var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firmware-list" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "title" }),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
                icon: "el-icon-plus",
              },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = true
                },
              },
            },
            [_vm._v("新建测试任务")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "任务名称" } }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间" },
          }),
          _c("el-table-column", {
            attrs: { formatter: _vm.statusFormatter, label: "状态" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "270" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    scope.row.state == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "operate",
                              disabled: _vm.rolesCode === "SALE",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.terminateTestTaskFun(scope.row)
                              },
                            },
                          },
                          [_vm._v("终止")]
                        )
                      : _vm._e(),
                    scope.row.state == 2
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.rolesCode === "SALE",
                              type: "text",
                              size: "operate",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteTestTaskFun(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.current,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.uploadLoading,
              expression: "uploadLoading",
            },
          ],
          attrs: {
            title: "新建测试任务",
            visible: _vm.dialogVisible,
            width: "628px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "custom-class": "test-task-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "任务名称", prop: "name" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [_vm._v("任务名称")]),
                                  _vm._v(" \n              "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "支持中英文和数字,长度2-32,名称不可重复",
                                        placement: "bottom",
                                        effect: "light",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont icon-wenhao",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入任务名称" },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "任务类型", prop: "type" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择任务类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "type", $$v)
                                },
                                expression: "form.type",
                              },
                            },
                            _vm._l(_vm.typeList, function (item) {
                              return _c("el-option", {
                                key: item.type,
                                attrs: { label: item.name, value: item.type },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升级版本号",
                            prop: "currentVersion",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              minlength: "1",
                              disabled: true,
                              "show-word-limit": "",
                              placeholder: "当前版本号",
                            },
                            model: {
                              value: _vm.form.currentVersion,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "currentVersion", $$v)
                              },
                              expression: "form.currentVersion",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "可升级版本号",
                            prop: "downgradeVersion",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                placeholder: "请选择可升级版本号",
                              },
                              on: { change: _vm.downgradeVersionChange },
                              model: {
                                value: _vm.form.downgradeVersion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "downgradeVersion", $$v)
                                },
                                expression: "form.downgradeVersion",
                              },
                            },
                            _vm._l(_vm.DowngradeVersionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.version,
                                  value: item.version,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升降级次数",
                            prop: "executionNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "200",
                              "show-word-limit": "",
                              placeholder: "请输入升降级次数",
                            },
                            model: {
                              value: _vm.form.executionNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "executionNumber", $$v)
                              },
                              expression: "form.executionNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "特定设备", prop: "deviceId" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "200",
                              "show-word-limit": "",
                              placeholder: "请输入设备id , 只支持一个设备",
                            },
                            model: {
                              value: _vm.form.deviceId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "deviceId", $$v)
                              },
                              expression: "form.deviceId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "14" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClose()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "测试任务详情",
            visible: _vm.drawer,
            direction: _vm.direction,
            size: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.taskLoading,
                  expression: "taskLoading",
                },
              ],
            },
            [
              _c("div", { staticClass: "taskInfo" }, [
                _c(
                  "div",
                  { staticClass: "InfoTitle" },
                  [
                    _vm._v("任务基本信息\n          "),
                    _c(
                      "el-button",
                      {
                        staticClass: "refresh",
                        attrs: {
                          type: "add",
                          size: "mini",
                          icon: "el-icon-refresh-right",
                        },
                        on: { click: _vm.handleDetails },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("任务名称")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.name)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("任务类型")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.type)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("升级版本号")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.form.currentVersion)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("可升级版本号")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.downgradeVersion)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "taskInfo" }, [
                _c("div", { staticClass: "InfoTitle" }, [
                  _vm._v("任务执行结果"),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("升降级次数")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.executionNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("执行次数")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.finishNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("执行成功次数")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.finishSuccessNumber)),
                  ]),
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.dynamicLink,
                      rel: "opener",
                      target: "_blank",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "refresh",
                        attrs: { type: "add", size: "mini" },
                      },
                      [_vm._v("查看ota任务具体数据")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }